import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useTranslation } from 'react-i18next';
import './AboutUs.css';

const AboutUs = ({ isSection = false }) => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className={`about-us-page ${isSection ? 'section-view' : ''}`} style={isSection ? { padding: '50px 0', background: '#fff' } : {}}>
      {/* Hero Section - Hide if part of the one-page scroll to avoid double hero */}
      {!isSection && (
        <div className="hero-section" style={{ backgroundImage: `url('./images/aboutus/hero.jpg')` }}>
          <div className='abouthero1' data-aos="fade-up">
            <h1>{t('about_hero_title')}</h1>
            <div className="glass-image-box">
              <img src='./images/aboutus/about.png' alt="Hero" />
            </div>
          </div>
          <div className='abouthero2' data-aos="fade-up" >
            <div className='aboutherozoom'>
              <p>{t('about_hero_desc')}</p>
            </div>
          </div>
        </div>
      )}
      {/* Main Content */}
      <div className="container" style={isSection ? { maxWidth: '1200px', margin: '0 auto' } : {}}>
        {isSection && (
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 className="heading-md" style={{ color: "var(--color-primary-red)" }}>{t('about_who_we_are')}</h2>
            <div className="text-body" style={{ maxWidth: '800px', margin: '0 auto', marginTop: '20px' }}>
              <p>{t('about_intro')}</p>
            </div>
          </div>
        )}
        {/* Board of Directors */}
        <div className="members" style={isSection ? { padding: '0' } : {}}>
          <div className="director-section" data-aos="fade-in">
            <h2 className={isSection ? "heading-lg" : ""} style={isSection ? { fontSize: '2rem', textAlign: 'center', marginBottom: '40px' } : {}}>
              {t('about_directors_title')}
            </h2>
            <div className="directors-container" style={isSection ? { justifyContent: 'center', gap: '10px' } : {}}>
              {[
                { name: 'Mr. Krishantha', role: t('about_director_chairman'), img: './images/aboutus/dir1.jpg' },
                { name: 'Mr. P. P. Weerasinghe', role: t('about_director_licensee'), img: './images/aboutus/dir2.jpg' },
                { name: 'Mr. R. A. Krishantha', role: t('about_director_director'), img: './images/aboutus/dir3.jpg' },
                { name: 'Dr. Chamil Kumara', role: t('about_director_director'), img: './images/aboutus/kumara.jpg' },
                { name: 'Mrs. Sujeewa Nilanthi', role: t('about_director_manager'), img: './images/aboutus/dir4.jpg' }
              ].map((director, i) => (
                <div className="director-card glass-panel" key={i} data-aos="fade-in" data-aos-delay={i * 100} style={isSection ? { background: '#fff' } : {}}>
                  <img src={director.img} alt={director.name} />
                  <p style={{ fontWeight: 'bold', fontSize: '1.1rem', marginTop: '10px' }}>{director.name}</p>
                  <p className="role" style={{ color: 'var(--color-primary-red)' }}>{director.role}</p>
                </div>
              ))}
            </div>
          </div>
          {/* Our Staff */}
          <div className="staff-section" data-aos="fade-up">
            <h2 className={isSection ? "heading-lg" : ""} style={isSection ? { fontSize: '2rem', textAlign: 'center', marginBottom: '40px' } : {}}>
              {t('about_staff_title')}
            </h2>
            <div className="staff-container">
              {[
                { name: 'Nishani Elvitigala', img: './images/aboutus/Nishani Elvitigala.jpg' },
                { name: 'Dihani Frank', img: './images/aboutus/Dihani Frank.jpg' },
                { name: 'Gayana Weerasena', img: './images/aboutus/Gayana Weerasena.jpg' },
                { name: 'Dilani Withanage', img: './images/aboutus/Dilani Withanage.jpg' },
                { name: 'Randima Edirisighe', img: './images/aboutus/Randima Edirisighe.jpg' }
              ].map((staff, i) => (
                <div className="staff-card" key={i} data-aos="fade-up" data-aos-delay={i * 100}>
                  <img src={staff.img} alt={staff.name} />
                  <p>{staff.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Motivational Section */}
        <section id="about-end" className="about-end-section" data-aos="fade-in" style={isSection ? { background: 'transparent', boxShadow: 'none' } : {}}>
          <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', textAlign: 'center' }}>
            <h2 className="heading-md">{t('about_end_title')}</h2>
            <p className="text-body" style={{ maxWidth: '700px' }}>
              {t('about_end_desc')}
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
